module.exports = __webpack_public_path__ + "img/x.1f27c125.png";